import { render, staticRenderFns } from "./EmployeesPage.vue?vue&type=template&id=53dd2546&"
import script from "./EmployeesPage.vue?vue&type=script&lang=js&"
export * from "./EmployeesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports